export default __webpack_public_path__ + "static/media/Downlaod.7217c9b8.svg";